import moment from "moment";
class group {
  constructor(id, name, dateStart, dateEnd) {
    this.id = id;
    this.name = name;
    this.dateStart = dateStart
      ? moment.utc(dateStart).format("DD-MM-YYYY")
      : null;
    this.dateEnd = dateEnd ? moment.utc(dateEnd).format("DD-MM-YYYY") : null;
    this.dateStartInput = dateStart
      ? moment.utc(dateStart).format("YYYY-MM-DD")
      : null;
    this.dateEndInput = dateEnd
      ? moment.utc(dateEnd).format("YYYY-MM-DD")
      : null;
  }
  static fromJson({ grupoId, nombre, fecDesde, fecHasta }) {
    return new group(grupoId, nombre, fecDesde, fecHasta);
  }
}
export default group;
